import { createContext, useContext } from 'react';

export type PopupContextType = {
  opened: boolean;
  close(): void;
  redirect(url?: string | URL, target?: string): void;
};

export const PopupContext = createContext<PopupContextType>({
  opened: false,
  close: () => undefined,
  redirect: () => undefined
});

export const usePopup = () => useContext(PopupContext);
